import { render } from "./IdentidadGollumView.vue?vue&type=template&id=45b5783a&scoped=true"
import script from "./IdentidadGollumView.vue?vue&type=script&lang=js"
export * from "./IdentidadGollumView.vue?vue&type=script&lang=js"

import "./IdentidadGollumView.vue?vue&type=style&index=0&id=45b5783a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b5783a"]])

export default __exports__